import normalize from "json-api-normalizer";
import get from "lodash/get";
import { push } from "connected-react-router";

import {
  ASYNC_START,
  ASYNC_END,
  FETCH_PRODUCT_GROUPS_SUCCESS,
  SAVE_PRODUCT_GROUP_SUCCESS,
  SAVE_PRODUCT_GROUP_FAILED,
  FETCH_PRODUCT_GROUPS_FAILED
} from "./types";
import ProductGroupsService from "../services/product-groups.service";
import NotificationService from "../services/notification.service";

export const fetchProductGroups = () => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");

  dispatch({ type: ASYNC_START });

  const result = await ProductGroupsService.getAll(tenantSlug);
  dispatch({ type: ASYNC_END });

  const { productGroups } = normalize(result.data);
  dispatch({
    type: FETCH_PRODUCT_GROUPS_SUCCESS,
    productGroups: productGroups || {}
  });
};

export const fetchProductGroup = slug => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  try {
    dispatch({ type: ASYNC_START });
    const result = await ProductGroupsService.get(slug, tenantSlug);
    dispatch({ type: ASYNC_END });
    const { productGroups } = normalize(result.data);
    dispatch({
      type: FETCH_PRODUCT_GROUPS_SUCCESS,
      productGroups
    });
  } catch (e) {
    dispatch(fetchProductGroupFailed(get(e, "response.data.errors")));
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Failed featching the product group! ${NotificationService.handleMessage(e)}`);
  }
};

export const createProductGroup = productGroupAttributes => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  try {
    dispatch({ type: ASYNC_START });
    await ProductGroupsService.create(tenantSlug, productGroupAttributes);
    dispatch(productGroupSaved());
    dispatch({ type: ASYNC_END });
    dispatch(push("/productGroups"));
    NotificationService.addSuccess("Product group successfully created!");
  } catch (e) {
    dispatch(productGroupSaveFailed(get(e, "response.data.errors")));
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Failed creating the product group! ${NotificationService.handleMessage(e)}`);
  }
};

export const updateProductGroup = (slug, productGroupAttributes) => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  try {
    dispatch({ type: ASYNC_START });
    await ProductGroupsService.put(tenantSlug, slug, productGroupAttributes);
    dispatch(productGroupSaved());
    dispatch({ type: ASYNC_END });
    dispatch(push("/productGroups"));
    NotificationService.addSuccess("Product group successfully updated!");
  } catch (e) {
    dispatch(productGroupSaveFailed(get(e, "response.data.errors")));
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Failed updating the product group! ${NotificationService.handleMessage(e)}`);
  }
};

export const productGroupSaved = () => {
  return {
    type: SAVE_PRODUCT_GROUP_SUCCESS
  };
};

export const productGroupSaveFailed = errors => {
  return {
    type: SAVE_PRODUCT_GROUP_FAILED,
    errors
  };
};

export const fetchProductGroupFailed = errors => {
  return {
    type: FETCH_PRODUCT_GROUPS_FAILED,
    errors
  };
};
